class CharacterCounter {
  constructor(DOMelement) {
     try {
      this.charCounters = DOMelement;

      this.charCounters.forEach(element => {
        let textareaEl = element.previousElementSibling;
        if (textareaEl && (textareaEl.type.toLowerCase() === 'textarea' || textareaEl.type.toLowerCase() === 'text')){
          this.countElements(textareaEl, element);
          textareaEl.addEventListener("input", event => {
              this.countElements(textareaEl, element);
          });
        }
      });
      
    }catch (error) {
        console.log(error);
    }
  }

  countElements(textEl, countEl) {
      const currentLength = textEl.value.length;
      countEl.querySelector('.charNb').innerHTML = currentLength;
  }
}
export default CharacterCounter;